import type { PlanConfig } from "../types";

interface PlanEditorProps {
    selectedPlan: PlanConfig;
}

export function PlanEditor({ selectedPlan }: PlanEditorProps) {
    return (
        <div className="rc-plan-editor">
            <section className="rc-block rc-plan-context-card">
                <h3>{selectedPlan.name} - Plan Context</h3>
                <p className="rc-block-hint">This health plan controls the client context for report configuration. Report filters are configured per report on the Setup tab.</p>
                <div className="rc-plan-context-grid">
                    <div>
                        <span>Health Plan</span>
                        <strong>{selectedPlan.name || "Not selected"}</strong>
                    </div>
                    <div>
                        <span>Client Name</span>
                        <strong>{selectedPlan.clientName || "ClientInfo"}</strong>
                    </div>
                    <div>
                        <span>Client ID</span>
                        <strong>{selectedPlan.clientId || "Not available"}</strong>
                    </div>
                    <div>
                        <span>Report Plan</span>
                        <strong>{selectedPlan.planName || selectedPlan.planKey || selectedPlan.reportPlanId || "Default report plan"}</strong>
                    </div>
                </div>
            </section>
        </div>
    );
}
